import React from "react";
import Model from "@tripian/model";
import { PreLoading } from "@tripian/react";
import classes from "./TravelifyContainer.module.scss";

interface ITravelifyContainer {
  show: boolean;
  travelifyUrl?: string;
  isLoading: boolean;
  t: (value: Model.TranslationKey) => string;
}

const TravelifyContainer: React.FC<ITravelifyContainer> = ({
  show,
  travelifyUrl,
  isLoading,
  t,
}) => {
  const containerClasses = [classes.travelifyContainer];
  if (!window.tconfig.SHOW_OVERVIEW)
    containerClasses.push("trip-layout-container-height");
  else containerClasses.push("trip-layout-container-height-tab");
  if (show) containerClasses.push(classes.containerOpen);
  else containerClasses.push(classes.containerClose);

  if (!show) {
    return null;
  }

  return (
    <div className={containerClasses.join(" ")}>
      <div className="flex flex-col h-full mb-16 md:mb-0 items-center justify-center p-8">
        {isLoading ? (
          <div className="flex flex-col h-full items-center justify-center">
            <PreLoading />
          </div>
        ) : travelifyUrl ? (
          <div className="text-center max-w-md">
            <p className="text-gray-700 mb-6 text-base">
              {t("travelify.seeAllToursAndActivities")}
            </p>
            <button
              onClick={() => window.open(travelifyUrl, "_blank")}
              className="bg-primary-color text-white text-lg px-8 py-2 rounded-full font-semibold hover:bg-primary-color-dark transition-colors duration-200 shadow-lg hover:shadow-xl"
            >
              {t("travelify.openVacavia")}
            </button>
          </div>
        ) : (
          <div className="flex flex-col h-full items-center justify-center mt-10 text-gray-500">
            {t("trips.myTrips.localExperiences.toursEmpty")}
          </div>
        )}
      </div>
    </div>
  );
};

export default TravelifyContainer;
